import { Flex, Text } from '@backstage/ui';
import { RiPulseLine } from '@remixicon/react';

export const EmptyState = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => (
  <Flex
    direction="column"
    align="center"
    justify="center"
    gap="3"
    py="var(--bui-space-6)"
  >
    <RiPulseLine aria-hidden size={48} color="var(--bui-fg-secondary)" />
    <Text variant="title-x-small">{title}</Text>
    <Text variant="body-medium" color="secondary">
      {description}
    </Text>
  </Flex>
);
